import VuetifyToast from "vuetify-toast-snackbar-ng";
import Loader from "./base/Loader.vue";
import dynamic_select from "./components/general/dynamicSelect.vue";
import multiple_select from "./components/general/multipleSelect.vue";
import date_select from "./components/general/dateSelect.vue";
import plan_picker from "./components/general/planpicker/planPicker.vue";
import cita_picker from "./components/general/planpicker/citapicker.vue";
import plan_show from "./components/general/planpicker/planShow.vue";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import Vue, {
    h
} from "vue";
import moment from "moment";
import setup from "../vue_app/interceptors/interceptors";
import {
    VueMaskDirective
} from "v-mask";
import commanumInput from "./components/general/commanumInput.vue";
import VueApexCharts from "vue-apexcharts";
import axios from "axios";
import {lodash} from "lodash";

export default {
    init() {
        window._ = lodash;
        /**
         * We'll load the axios HTTP library which allows us to easily issue requests
         * to our Laravel back-end. This library automatically handles sending the
         * CSRF token as a header based on the value of the "XSRF" token cookie.
         */

        window.axios = axios;

        window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
        axios.defaults.withCredentials = true;
        axios.defaults.headers.common.Authorization = `Bearer ${localStorage.getItem(
            "id_token"
        )}`;
        axios.defaults.headers.common.user_id = `${localStorage.getItem(
            "user_id"
        )}`;

        setup();
        Vue.filter("hora_formated", function(val) {
            if (val == null) return "";

            let str = val.toString().split(".");
            if (str.length > 1) {
                return str[0].toString().padStart(2, "0") + ":30";
            }
            return val.toString().padStart(2, "0") + ":00";
        });
        Vue.filter("horas_to_form", function(val) {
            if (val == null) return "0h 0m";

            let str = val.toString().split(".");
            if (str.length > 1) {
                const hora = str[0];
                const minutos = parseInt(str[1]) * 0.6;
                return `${hora}h ${minutos.toFixed(0)}m`;
            }
            return val.toString() + "h 0m";
        });

        Vue.directive("mask", VueMaskDirective);
        Vue.filter("format_date", function(value) {
            let str = ((value + " ").split(" ")[0] + "T").split("T")[0].split("-");
            return `${str[2]}-${str[1]}-${str[0]}`;
        });
        Vue.filter("format_hours", function(hours) {
            // Get the integer part of the hours
            let h = Math.floor(hours);
            // Get the fractional part of the hours and convert it to minutes
            let m = Math.round((hours - h) * 60);

            // If minutes are less than 10, pad with a leading zero
            if (m < 10) {
                m = '0' + m;
            }

            return `${h}:${m}`;
        });
        Vue.filter("format_date_time", function(value) {
            let time = (value + "T").split("T")[1].split(":");

            let str = (value + "T").split("T")[0].split("-");
            return `${str[2]}-${str[1]}-${str[0]} ${time[0]}:${time[1]}`;
        });
        Vue.filter("format_date_time_madrid", function(value) {
            let time = (value + "T").split("T")[1].split(":");

            let str = (value + "T").split("T")[0].split("-");
            return `${str[2]}-${str[1]}-${str[0]} ${parseInt(time[0]) + 2}:${time[1]}`;
        });
        Vue.filter("decimalComma", function(value) {
            // console.log(value);
            if (value == null) return "";
            return value.toString().replace(".", ",");
        });
        Vue.filter("localeNumber", function(value) {
            // console.log(value);
            if (value == null) return "";
            return parseFloat(value.toString()).toFixed(2).replace(".", ",");
        });
        Vue.use(moment);
        Vue.component("v-text-field-comma", commanumInput);
        Vue.component("dynamic-select", dynamic_select);
        Vue.component("multiple-select", multiple_select);
        Vue.component("date-select", date_select);
        Vue.component("plan-picker", plan_picker);
        Vue.component("cita-picker", cita_picker);

        Vue.component("plan-show", plan_show);

        Vue.component("loader", Loader);
        Vue.use(VueApexCharts);

        Vue.component("apexchart", VueApexCharts);
        //Apex.fill.colors = ["#8521e31", "#8521e31", "#8521e31"];
        Apex.chart = {
            locales: [{
                    name: "en",
                    options: {
                        months: [
                            "January",
                            "February",
                            "March",
                            "April",
                            "May",
                            "June",
                            "July",
                            "August",
                            "September",
                            "October",
                            "November",
                            "December",
                        ],
                        shortMonths: [
                            "Jan",
                            "Feb",
                            "Mar",
                            "Apr",
                            "May",
                            "Jun",
                            "Jul",
                            "Aug",
                            "Sep",
                            "Oct",
                            "Nov",
                            "Dec",
                        ],
                        days: [
                            "Sunday",
                            "Monday",
                            "Tuesday",
                            "Wednesday",
                            "Thursday",
                            "Friday",
                            "Saturday",
                        ],
                        shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
                        toolbar: {
                            exportToSVG: "Download SVG",
                            exportToPNG: "Download PNG",
                            exportToCSV: "Download CSV",
                            menu: "Menu",
                            selection: "Selection",
                            selectionZoom: "Selection Zoom",
                            zoomIn: "Zoom In",
                            zoomOut: "Zoom Out",
                            pan: "Panning",
                            reset: "Reset Zoom",
                        },
                    },
                },
                {
                    name: "es",
                    options: {
                        months: [
                            "Enero",
                            "Febrero",
                            "Marzo",
                            "Abril",
                            "Mayo",
                            "Junio",
                            "Julio",
                            "Agosto",
                            "Septiembre",
                            "Octubre",
                            "Noviembre",
                            "Diciembre",
                        ],
                        shortMonths: [
                            "Ene",
                            "Feb",
                            "Mar",
                            "Abr",
                            "May",
                            "Jun",
                            "Jul",
                            "Ago",
                            "Sep",
                            "Oct",
                            "Nov",
                            "Dic",
                        ],
                        days: [
                            "Domingo",
                            "Lunes",
                            "Martes",
                            "Miércoles",
                            "Jueves",
                            "Viernes",
                            "Sábado",
                        ],
                        shortDays: ["Dom", "Lun", "Mar", "Mie", "Jue", "Vie", "Sab"],
                        toolbar: {
                            exportToSVG: "Descargar SVG",
                            exportToPNG: "Descargar PNG",
                            exportToCSV: "Descargar CSV",
                            menu: "Menu",
                            selection: "Seleccionar",
                            selectionZoom: "Seleccionar Zoom",
                            zoomIn: "Aumentar",
                            zoomOut: "Disminuir",
                            pan: "Navegación",
                            reset: "Reiniciar Zoom",
                        },
                    },
                },
            ],
            defaultLocale: "es",
        };
        /**
         * Echo exposes an expressive API for subscribing to channels and listening
         * for events that are broadcast by Laravel. Echo and event broadcasting
         * allows your team to easily build robust real-time web applications.
         */

        // import Echo from 'laravel-echo';

        // window.Pusher = require('pusher-js');

        // window.Echo = new Echo({
        //     broadcaster: 'pusher',
        //     key: process.env.MIX_PUSHER_APP_KEY,
        //     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
        //     forceTLS: true
        // });

        Vue.use(VueSweetalert2, {});
        const swal_custom = {
            install(app, options) {
                app.prototype.$custom_error = (key) => {
                    app.prototype.$swal({
                        icon: "error",
                        title: "Error",
                        text: key,
                    });
                };
                app.prototype.$custom_success = (key) => {
                    app.prototype.$swal({
                        icon: "success",
                        title: "Exitoso",
                        text: key,
                    });
                };
            },
        };

        Vue.filter("format_precio", function(numero) {
            let float_numero = parseFloat(numero);
            if (float_numero != null && !isNaN(float_numero))
                return `${float_numero.toFixed(2).replace(".", ",")}€`;
            return "0.00€";
        });
        Vue.filter("format_numero", function(numero) {
            let float_numero = parseFloat(numero);
            if (float_numero) {
                if (float_numero != null && !isNaN(float_numero))
                    return `${float_numero.toFixed(2).replace(".", ",")}`;
            }
            return "0,00";
        });

        Vue.prototype.$customFilterVAutocomplete = function(item, queryText){
            const text = item.numero + ' ' + item.partida;
            return text.toLowerCase().includes(queryText.toLowerCase());
        };

        Vue.use(swal_custom);
        Vue.use(VuetifyToast, {
            x: "right",
            y: "top",
            color: "info",
            icon: "mdi-info",
            timeout: 3000,
            dismissable: true,
            autoHeight: false,
            multiLine: false,
            vertical: false,
            shorts: {
                error: {
                    color: "red",
                },
                sucs: {
                    color: "green",
                },
                warn: {
                    color: "orange",
                },
            },
            property: "$toast",
        });
    }
}